// removed by extract-text-webpack-plugin
module.exports = {"form":"_3qnbI1mEC8V4DrIgTQn26H","spin":"_3F1Y0DmfvCMGPRPgJgngB-"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/Input/Form/styles.scss
// module id = 933
// module chunks = 18